import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

/**
 * 
 * @param {*} props{open(state), dialogTitle, dialogContent, onConfirm, closeDialog()}
 * @returns 
 */
export default function MyDialog(props) {
    const [open, setOpen] = React.useState(false);
    const { dialogTitle, dialogContent, onConfirm } = props

    function handleClose() {
        props.closeDialog()
    };

    React.useEffect(() => {
        setOpen(props.open)
    }, [props])

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {dialogTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {dialogContent}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button onClick={onConfirm} >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}